module.exports = __webpack_public_path__ + "img/1.0e78f27f.svg";